import { faUser } from '@fortawesome/pro-regular-svg-icons';
import { faEnvelope, faPhone } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ContactOrCompanyLabel } from 'assets/js/pages/contacts/ContactOrCompanyLabel';
import { CopyButton } from 'components/copy-button';
import * as LinkedResourcePopover from 'components/tasks/LinkedResourcePopover';
import { EmptyData } from 'components/util';
import { ContactType } from 'constants/contacts';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { getFormattedPhoneNumber } from 'helpers/formatting';
import { LinkableContact } from 'types/domain';

const ContactResourcePopover = ({ contact }: { contact?: LinkableContact }) => {
    const { accountId } = useCurrentAccount();
    if (!contact) return null;

    return (
        <LinkedResourcePopover.Root>
            <LinkedResourcePopover.Header>
                <FontAwesomeIcon icon={faUser} className="text-gray-500" />
                <LinkedResourcePopover.Link
                    to={`/accounts/${accountId}/${contact.type === ContactType.Company ? 'companies' : 'contacts'}/${contact.id}`}
                >
                    <ContactOrCompanyLabel contact={contact} />
                </LinkedResourcePopover.Link>
            </LinkedResourcePopover.Header>

            <LinkedResourcePopover.Content>
                <div className="flex items-center justify-between gap-10">
                    <div className="flex flex-col">
                        <p className="text-sm text-gray-500">Email</p>
                        <p className="flex items-center gap-1 text-base text-gray-900">
                            {contact.primary_email && (
                                <>
                                    {contact.primary_email}
                                    <CopyButton text={contact.primary_email} />
                                </>
                            )}
                        </p>
                    </div>
                    {contact.primary_email ? (
                        <a
                            href={`mailto:${contact.primary_email}`}
                            className="bg-blue-25 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full"
                        >
                            <FontAwesomeIcon icon={faEnvelope} className="text-blue-500" />
                        </a>
                    ) : (
                        <EmptyData />
                    )}
                </div>

                <div className="flex items-center justify-between gap-10">
                    <div className="flex flex-col">
                        <p className="text-sm text-gray-500">Phone</p>
                        <p className="flex items-center gap-1 text-base text-gray-900">
                            {contact.primary_phone ? (
                                <>
                                    {getFormattedPhoneNumber(contact.primary_phone)}
                                    <CopyButton text={contact.primary_phone} />
                                </>
                            ) : (
                                <EmptyData />
                            )}
                        </p>
                    </div>
                    {contact.primary_phone && (
                        <a
                            href={`tel:${contact.primary_phone}`}
                            className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-gray-100"
                        >
                            <FontAwesomeIcon icon={faPhone} className="text-blue-500" />
                        </a>
                    )}
                </div>
            </LinkedResourcePopover.Content>
        </LinkedResourcePopover.Root>
    );
};

export { ContactResourcePopover };
